import { render, staticRenderFns } from "./MobileTransactionHistory.vue?vue&type=template&id=b15cd3ba&"
import script from "./MobileTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./MobileTransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./MobileTransactionHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports